import * as React from 'react';
import * as classnames from 'classnames';
import { observer } from 'mobx-react';
import { ProductImageBadge } from '../../views/product-image-badge/ProductImageBadge';
import { Product } from '../../domain/entities/Product';
import { Sku } from '../../domain/entities/Sku';

export interface IBadgeProps {
    product: Product;
    selectedSku: Sku;
}
export interface IProductBadge extends IBadgeProps {
    className?: string;
}

export const ProductBadge = observer((props: IProductBadge) => {
    const productBadgeWrapperClassNames = classnames(
        'elc-product-badge-wrapper',
        'js-product-badge-wrapper',
        props.className
    );

    const productBadgeClassNames = classnames(
        'elc-product-badge',
        'js-product-badge',
        props.className
    );

    const { product, selectedSku } = props;

    const badgeText = selectedSku.skuBadge ? selectedSku.skuBadge : product.productBadge;
    const badgeImage = selectedSku.skuBadgeImage
        ? selectedSku.skuBadgeImage
        : product.productBadgeImage;
    const imageBadgeProps = {
        productDisplayName: product.displayName,
        productBadgeImage: product.productBadgeImage,
        skuBadgeImage: selectedSku.skuBadgeImage
    };

    return (
        <div className={productBadgeWrapperClassNames}>
            {badgeText && <p className={productBadgeClassNames}>{badgeText}</p>}
            {badgeImage && <ProductImageBadge {...imageBadgeProps} />}
        </div>
    );
});
